import Vue from 'vue'
import App from './App.vue'
import router from './router/index';
import echarts from 'echarts'
import 'echarts/map/js/china'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import api from './api/index';
import i18n from './plugins/element.js'
import 'default-passive-events'
Vue.prototype.$api = api
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.use(ElementUI)

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
